import React from "react";
import { Card, Select, Input, Space, Skeleton } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { ALL_USERS_VALUE } from "../../constants/gitlab";

const { Option } = Select;

const FiltersBar = ({
  gitlabUsers,
  selectedUser,
  onUserChange,
  isLoadingUsers,
  search,
  onSearchChange,
  labelFilter,
  onLabelChange,
  milestoneFilter,
  onMilestoneChange,
  statusFilter,
  onStatusChange,
  labelOptions,
  milestoneOptions,
}) => {
  if (isLoadingUsers) {
    return (
      <Card className="filters-card" variant="borderless">
        <Space wrap size="middle" className="filters-card__row">
          <Skeleton.Input active style={{ width: 260, height: 32 }} />
          <Skeleton.Input active style={{ width: 260, height: 32 }} />
          <Skeleton.Input active style={{ width: 160, height: 32 }} />
          <Skeleton.Input active style={{ width: 180, height: 32 }} />
          <Skeleton.Input active style={{ width: 160, height: 32 }} />
        </Space>
      </Card>
    );
  }

  return (
    <Card className="filters-card" variant="borderless">
      <Space wrap size="middle" className="filters-card__row">
        <Select
          placeholder="Filter by user"
          value={selectedUser}
          onChange={onUserChange}
          showSearch
          style={{ minWidth: 260 }}
          optionFilterProp="label"
        >
          <Option value={ALL_USERS_VALUE} label="All Users">
            All Users
          </Option>
          {gitlabUsers.map((user) => (
            <Option
              key={user.username}
              value={user.username}
              label={`${user.name} ${user.username}`}
            >
              {user.name} ({user.username})
            </Option>
          ))}
        </Select>

        <Input
          allowClear
          prefix={<SearchOutlined />}
          placeholder="Search issues, projects, refs..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          style={{ minWidth: 260 }}
        />

        <Select
          value={labelFilter}
          onChange={onLabelChange}
          style={{ minWidth: 160 }}
          placeholder="Label"
        >
          <Option value="all">All Labels</Option>
          {labelOptions.map((label) => (
            <Option key={label} value={label}>
              {label}
            </Option>
          ))}
        </Select>

        <Select
          value={milestoneFilter}
          onChange={onMilestoneChange}
          style={{ minWidth: 180 }}
          placeholder="Milestone"
        >
          <Option value="all">All Milestones</Option>
          {milestoneOptions.map((milestone) => (
            <Option key={milestone} value={milestone}>
              {milestone}
            </Option>
          ))}
        </Select>

        <Select
          value={statusFilter}
          onChange={onStatusChange}
          style={{ minWidth: 160 }}
        >
          <Option value="all">All Status</Option>
          <Option value="overdue">Overdue</Option>
          <Option value="dueSoon">Due Soon</Option>
          <Option value="exceeded">Exceeded Estimate</Option>
        </Select>
      </Space>
    </Card>
  );
};

export default FiltersBar;
